import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

export const typTransakceSelect = [
    {
        value: '',
        labelcz: 'VYBERTE'
    },
    {
        value: ETypTransakce.NAKUP,
        labelcz: 'SS_DETAIL_FILTR_NAKUP'
    },
    {
        value: ETypTransakce.PRODEJ,
        labelcz: 'SS_DETAIL_FILTR_PRODEJ'
    }
];
